import { useContext } from "react"
import { ToolContext } from "../../../../../core/context/ToolContext"
import { Box, Grid, TextField, Typography } from "@mui/material"

export const FormBody = ({handleChange}) =>{
    const {reconciliation_state} = useContext(ToolContext)
    const {reconData, isToReconcile} = reconciliation_state

    return(
        <Grid container spacing={1}>
            <Grid item xs={12} lg={6}><TextField fullWidth label="Total Sales" name="totalSales" type="number" value={reconData.data.totalSales} disabled/></Grid>
            <Grid item xs={12} lg={6}><TextField fullWidth label="Actual Cash" name="actualCash" disabled={!isToReconcile.data} value={reconData.data.actualCash} onChange={handleChange} error={reconData.data.actualCash === ""}/></Grid>
            <Grid item xs={12}>
                <Box textAlign="right">
                    {reconData.data.actualCash !== "" && reconData.data.actualCash !== undefined && reconData.data.actualCash !== null && !isToReconcile.data &&
                        <Typography sx={{color: parseFloat(reconData.data.totalSales) === parseFloat(reconData.data.actualCash) ? "green" : "red",fontWeight: 600}}>
                            {parseFloat(reconData.data.totalSales) === parseFloat(reconData.data.actualCash) ? "No Variance" : parseFloat(reconData.data.actualCash) > parseFloat(reconData.data.totalSales) ? `Over by ₱${(parseFloat(reconData.data.actualCash) - parseFloat(reconData.data.totalSales)).toFixed(2)}` : `Short by ₱${(parseFloat(reconData.data.totalSales) - parseFloat(reconData.data.actualCash)).toFixed(2)}`}
                        </Typography>
                    }
                </Box>
            </Grid>
        </Grid>
    )
}